import biggerSupplierBox from './biggerSupplierBox'
import box from './box'
import complianceBox from './complianceBox'
import complianceHexagons from './complianceHexagons'
import counter from './counter'
import hexagon from './hexagon'
import progressBar from './progressBar'
import rectangleTwoLabels from './rectangleTwoLabels'
import suppliersBox from './suppliersBox'

const components = {
  biggerSupplierBox,
  box,
  complianceBox,
  complianceHexagons,
  counter,
  hexagon,
  progressBar,
  rectangleTwoLabels,
  suppliersBox,
}

export default components
